import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getPhoneInputTestIds = createTestIds('phone-input', [
  'control',
  'country-code',
  ...elements
] as const);
